<template>
  <div>
    <ResourcesWeb v-if="!isMobile"></ResourcesWeb>
    <ResourcesMobile v-if="isMobile"></ResourcesMobile>
  </div>
</template>
<script>
import ResourcesWeb from './Resources-web.vue'
import ResourcesMobile from './Resource-mobile.vue'
export default {
  name: 'Resources',
  data() {
    return {
      isMobile: true
    }
  },
  components: {
    ResourcesWeb,
    ResourcesMobile
  },
  mounted() {
    const detectDeviceType = () =>
      /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
        ? 'Mobile'
        : 'Desktop'
    this.isMobile = detectDeviceType() === 'Mobile'
  },
  methods: {}
}
</script>
<style lang="less">
</style>
